import React, { useState } from 'react';
import salesServiceOrderService from '../../services/salesServiceOrderService';
import { downloadSalesServiceOrderPdf } from '../../utils/generateSalesServiceOrderPdf';

const SalesServiceOrderPdfButton = ({
  orderId,
  className = 'text-red-600 hover:text-red-800',
  title = 'Descargar PDF',
  onSuccess,
  onError,
  showLabel = false,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;

    setLoading(true);
    try {
      const response = await salesServiceOrderService.getServiceOrder(orderId);
      if (!response.success || !response.data) {
        throw new Error('No se pudo cargar la orden de servicio');
      }
      await downloadSalesServiceOrderPdf(response.data);
      onSuccess?.(response.data);
    } catch (error) {
      console.error('Error al generar PDF de orden de servicio:', error);
      onError?.(error?.message || 'Error al generar el PDF');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className={`inline-flex items-center gap-1 font-medium disabled:opacity-50 ${className}`}
      title={loading ? 'Generando PDF…' : title}
    >
      {loading ? (
        <span className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 3v4a1 1 0 001 1h4M9 13h6M9 17h4" />
        </svg>
      )}
      {showLabel ? <span className="text-xs uppercase tracking-wide">PDF</span> : null}
    </button>
  );
};

export default SalesServiceOrderPdfButton;
